import { render, staticRenderFns } from "./DeepPlayerCoreV2.vue?vue&type=template&id=4a45b7a6&scoped=true&"
import script from "./DeepPlayerCoreV2.vue?vue&type=script&lang=js&"
export * from "./DeepPlayerCoreV2.vue?vue&type=script&lang=js&"
import style0 from "./DeepPlayerCoreV2.vue?vue&type=style&index=0&id=4a45b7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a45b7a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VOverlay,VProgressCircular,VRow,VSpacer})
